import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Inject } from "@angular/core";
import { Folder } from "src/app/folder-model";
import { DataService } from "./../../data.service";
import { GUID } from "./../../guid";

import {
  FormArray,
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { ToastService } from "ng-uikit-pro-standard";
import { SharedDataService } from "src/app/shared-data.service";
import { FolderComponent } from "../folder.component";
@Component({
  selector: "app-newfolder",
  templateUrl: "./newfolder.component.html",
  styleUrls: ["./newfolder.component.scss"],
})
export class NewfolderComponent implements OnInit {
  // @Input() parentFolder: Folder;
  parentFolderId: "";

  isLoading = false;
  isError = false;
  errorMessage = "";
  guid: GUID;
  mode = "new";
  foldermode = "";

  folderId = "";

  detailForm = this.fb.group({
    label: "",
    name: new FormControl({ value: "", disabled: false }, Validators.required),
    foldertype: "Report",

    // iconname: "",
  });
  foldertypeSelect = [
    { value: "Report", label: "Report" },
    { value: "Dashboard", label: "Dashboard" },
    { value: "Document", label: "Document" },
    { value: "QuickText", label: "QuickText" },
    { value: "EmailTemplate", label: "EmailTemplate" },
  ];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private toastrService: ToastService,
    private dataService: DataService,
    private sharedDataService: SharedDataService,
    private dialogRef: MatDialogRef<FolderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    // this.route.queryParams.subscribe((params) => {
    //   this.foldermode =
    //     this.route.snapshot._urlSegment.children.primary.segments[2].path;
    //   this.parentFolderId =
    //     this.route.snapshot._urlSegment.children.primary.segments[3].path;
    //   // this.objectName = this.route.snapshot.params.objectname;
    // });

    // console.log(
    //   this.route.snapshot._urlSegment.children.primary.segments[3].path
    // );

    this.foldermode = this.data.foldermode;
    this.parentFolderId = this.data.parentfolderid;
    console.log(this.data);

    // this.route.queryParams.subscribe(params => {
    //   this.parentFolderId = params['parentId'];
    // });

    console.log(this.parentFolderId);
    console.log(this.foldermode);

    this.guid = new GUID();
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000,
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Metaobject Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark",
    };
    this.toastrService.warning(data, "", options);
  }

  save() {
    const formData = this.detailForm.value;

    this.isLoading = false;
    this.isError = false;
    if (this.detailForm.controls["label"].value.toString().trim() == "") {
      this.showWarning("Recordtype label is mandatory");
      return;
    }
    if (this.detailForm.controls["name"].value.toString().trim() == "") {
      this.showWarning("Recordtype name is mandatory");
      return;
    }

    if (this.detailForm.invalid) {
      this.errorMessage = "The fields [Label] and [Name] are mandatory.";
      return;
    }

    console.log("mode", this.mode);
    if (this.mode.toLowerCase() == "new") {
      this.folderId = this.guid.getGUID("folder");
    }

    //prepare data for saving: application
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      domain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.domain`),
      subdomain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.subdomain`),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      useralias: localStorage.getItem("crm_useralias"),
      data: {
        folder: {
          // primaryobjectname: this.metaobjectName,
          mode: "new",
          id: this.folderId,
          name: formData.name,
          labelname: formData.label,
          accesstype: "Public",
          parentfolderid: this.parentFolderId,
          foldertype: formData.foldertype,
          readonly: false,
        },
      },
    };

    console.log("postOption", postOption);

    this.isLoading = true;
    this.dataService.upsertFolder(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.showSuccess(res.message);
          this.isLoading = false;
          this.router.navigateByUrl("/home/reports");
          this.dialogRef.close();
        } else {
          console.log("error while saving");
          this.showError(res.message);
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.showError(err.message);
        this.isError = true;
        this.isLoading = false;
      }
    );

    // Create the new folder
    const newFolder: Folder = {
      id: this.folderId,
      name: formData.name,
      createdby: "Some User",
      createddate: new Date(),
      modifiedby: "Some User",
      modifieddate: new Date(),
      parentId: null, // Set parent ID as needed
    };

    // Set the new folder in the shared service
    this.sharedDataService.setNewFolder(newFolder);
  }
  fetchOldData(): any[] {
    return []; // Return existing data
  }
}
